import { FC, useMemo } from 'react';

import {
  Popover as MantinePopover,
  PopoverProps as MantinePopoverProps
} from '@mantine/core';

import { useMergeClassNames } from '../../utils';

import { PopoverOverrideClassNames } from './Popover.styles';

interface PopoverProps extends MantinePopoverProps {
  removePadding?: boolean;
}

type PopoverComponent<P> = FC<P> & {
  Target: typeof MantinePopover.Target;
  Dropdown: typeof MantinePopover.Dropdown;
};

const Popover: PopoverComponent<PopoverProps> = ({
  radius = 'xs',
  removePadding,
  ...rest
}) => {
  const classes = useMemo(
    () =>
      PopoverOverrideClassNames({
        noPadding: !!removePadding
      }),
    [removePadding]
  );

  const mergedClassNames = useMergeClassNames({
    classNames: [classes, rest.classNames]
  });

  return <MantinePopover {...rest} radius={radius} classNames={mergedClassNames} />;
};

Popover.Dropdown = MantinePopover.Dropdown;
Popover.Target = MantinePopover.Target;

export { Popover };
export type { PopoverProps };
